import { FC } from 'react';
import MenuItem from 'components/shared/generic/menuItem/presentational/MenuItem';
import { ZendeskCategory } from 'lib/type';

interface ZendeskFAQsProps {
    faqs?: ZendeskCategory[];
}

const ZendeskFAQs: FC<ZendeskFAQsProps> = ({ faqs }) => {
    return (
        <div
            className="zendesk-faqs"
            data-testid="zendesk-categories-container"
        >
            {faqs?.map(({ name, id }) => (
                <MenuItem
                    tracking
                    trackingLabel={`FAQS_CATEGORY_${name}`}
                    key={id}
                    title={name}
                    to={`/help/${id}`}
                />
            ))}
        </div>
    );
};

export default ZendeskFAQs;
